import { Editor } from 'grapesjs';
import { faWindow } from '@fortawesome/pro-regular-svg-icons/faWindow';
import { EditorComponentDefinition } from './types';
import { TabsWidgetTraits, tabsWidgetTraitsSchema } from './tabs/TabsWidgetTraits';

export const navigationComponentDefinition: EditorComponentDefinition = {
  id: 'navigations',
  icon: faWindow,
  category: 'Basic',
  getLabel: ({ t }) => t('editor.component.navigation'),
  component: NavigationGrapesComponent,
};

export const navigationContainerComponentDefinition: EditorComponentDefinition = {
  id: 'navigation-container',
  icon: navigationComponentDefinition.icon,
  getLabel: () => '',
  traits: {
    schema: tabsWidgetTraitsSchema,
    form: TabsWidgetTraits,
  },
};

function NavigationGrapesComponent(editor: Editor) {
  editor.DomComponents.addType(navigationComponentDefinition.id, {
    model: {
      defaults: {
        draggable: '[data-gjs-type=wrapper]',
        droppable: true,
        copyable: true,
        removable: true,
        traits: [],
        components: [
          {
            type: navigationContainerComponentDefinition.id,
          },
          {
            type: 'navigation-contents',
          },
        ],
      },
    },
  });

  editor.DomComponents.addType(navigationContainerComponentDefinition.id, {
    extend: 'tab-container',
    model: {
      defaults: {
        classes: ['navigation-bar'],
        attributes: {
          tabs: [{ contentId: null }, { contentId: null }, { contentId: null }],
          type: 'navigations',
        },
      },
    },
  });

  editor.DomComponents.addType('navigation-contents', {
    extend: 'tab-contents',
  });

  editor.DomComponents.addType('navigation-content', {
    extend: 'tab-content',
  });
}
